<template>
  <div class="content">
    <FileSelectWrapper
      :validFormats="$constants.files.acceptedCSVType"
      class="d-flex flex-column justify-center align-center"
      @selected="$emit('fileSelected', $event)"
    >
      <template slot-scope="{ selectFile, isDraggingFile }">
        <div
          class="uploader-container d-flex flex-column justify-center align-center"
          :class="{
            'uploader-container--dragging': isDraggingFile,
          }"
        >
          <v-icon :color="isDraggingFile ? 'blue' : 'grey'" large>
            mdi-file-excel
          </v-icon>

          <v-spacer class="mt-2 flex-grow-0" />

          <h2 class="mt-1 grey--text text--darken-2">
            {{ $t('media.drop_csv_message') }}
          </h2>

          <v-spacer class="mt-1 flex-grow-0" />

          <p class="mb-0 grey--text">{{ $t('common.or') }}</p>

          <v-spacer class="mt-1 flex-grow-0" />

          <Button
            color="primary"
            data-testId="fileUploader-button-browseFile"
            :text="$t('media.browse_files')"
            @click="
              selectFile(),
                trackPeopleNavigate({
                  element: 'browseFileButton',
                  section: 'fileSelector',
                })
            "
          />

          <v-spacer class="mb-3 flex-grow-0" />

          <p class="mb-0 grey--text text-overline">
            {{
              $t('media.supported_extensions_label', {
                supportedExtensions: $constants.files.acceptedCSVExtension.join(),
              })
            }}
          </p>
        </div>
      </template>
    </FileSelectWrapper>
  </div>
</template>

<script>
import FileSelectWrapper from '@/components/utils/FileSelectWrapper/FileSelectWrapper.vue'
import Button from '@/components/UI/Button'

import trackerMixin from '@/mixins/tracking/trackerMixin.vue'

export default {
  name: 'CSVFileLoader',

  mixins: [trackerMixin],

  components: {
    FileSelectWrapper,
    Button,
  },

  props: {
    allowMultipleSelect: Boolean,
  },
}
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  height: 65vh;
}

.uploader-container {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  border: 2px dashed $color-blue-grey-lighten1;
  overflow: hidden;
  transition: all 0.2s;

  &--dragging {
    background-color: var(--v-blue-lighten5);
    border-color: var(--v-primary-base);
  }
}
</style>
